import React from 'react';

import styles from './StickyButton.module.scss';

const StickyButton = ({ customStyles = '', children, ...props }) => {
  return (
    <div className={`${styles.stickyButton} ${customStyles}`} {...props}>
      <div className={styles.buttonWrap}>{children}</div>
    </div>
  );
};

export default StickyButton;
